export const AMOUNT_INPUT = {
  PRESET_1: 'preset1',
  PRESET_2: 'preset2',
  PRESET_3: 'preset3',
  PRESET_4: 'preset4',
  PRESET_5: 'preset5',
  PRESET_6: 'preset6',
  OTHER: 'other'
};

// * Config Object Types

export const MIN_DONATION_AMOUNT = 1;
export const MAX_DONATION_AMOUNT = 9999999.99;